import React from 'react'
import { tableData } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals"
import { formatDate } from "@ui-seeker/utils"
import { alpha, Box } from "@mui/material"
import { COMPARISON_TYPE } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@constants"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"

const mapColors = {
	[COMPARISON_TYPE.LESS]: dsColorNew.dangerRed,
	[COMPARISON_TYPE.MORE]: dsColorNew.appBlue
}

const evolutionIcons = {
	[COMPARISON_TYPE.LESS]: { color: dsColorNew.dangerRed, icon: "arrow-down" },
	[COMPARISON_TYPE.MORE]: { color: dsColorNew.successText, icon: "arrow-up" },
	[COMPARISON_TYPE.EQUAL]: { icon: "equals" },
}

export default function priceColumn(value) {

	return {
		name: value,
		headerAlign: "center",
		options: {
			filter: false,
			sort: false,
			customHeadLabelRender: () => <Box
				sx={{
					fontWeight: 600,
					display: 'block',
					textAlign: 'center'
				}}>
				{tableData.value.isDaily ? formatDate(value, { isString: true }) : value}
			</Box>,
			customBodyRowRenderLite: cellData => <PriceColumnCell cellData={cellData}/>,
		}
	}
}


function PriceColumnCell({ cellData }) {
	const {
		name,
		main_price,
		price,
		comparison_type,
		diff_price,
		noResult,
	} = cellData
	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "default" }}>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-around",
				borderRadius: "8px",
				// thin border and a light fill of the comparison colour, as the analyzers; N/A dashed
				border: (!noResult || !!main_price) ? '1px solid' : `1px dashed ${dsColorNew.grayBorder}`,
				width: 130,
				minHeight: 40,
				borderColor: (!noResult || !!main_price) ? (mapColors[comparison_type] ? alpha(mapColors[comparison_type], 0.45) : dsColorNew.grayBorder) : dsColorNew.grayBorder,
				backgroundColor: mapColors[comparison_type] ? alpha(mapColors[comparison_type], 0.08) : dsColorNew.white,
			}}
		>
			{/* Box, not Typography: the table theme fixes every Typography in a body cell at 13px */}
			<Box sx={{ py: 0.5, px: 1, width: '100%', textAlign: 'center' }}>
				<TooltipSeeker title="Main Price">
					<Box>
						<Box sx={{ fontSize: 15, fontWeight: 700, color: !!main_price ? dsColorNew.textTitle : dsColorNew.textSubtle }}>
							{!!main_price ? main_price : 'N/A'}
						</Box>
					</Box>
				</TooltipSeeker>
				{!!main_price && (!!price || !!diff_price) && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
					{!!price && <Box sx={{ fontSize: 11, color: dsColorNew.textMuted }}>{price}</Box>}
					{!!diff_price && <TooltipSeeker title={`Difference between main price and ${name} price`} componentsProps={{ sx: { display: "flex" } }}>
						<Box sx={{ display: "flex", alignItems: "center", gap: .25, color: evolutionIcons[comparison_type]?.color ?? dsColorNew.textMuted }}>
							<IconSeeker {...evolutionIcons[comparison_type]} sx={{ fontSize: 10 }}/>
							<Box sx={{ fontSize: 11 }}>{diff_price}%</Box>
						</Box>
					</TooltipSeeker>}
				</Box>}
			</Box>
		</Box>
	</Box>

}